<template>
  <div
    v-if="values.length === 0"
    class="flex flex-col space-y-10 items-center justify-center py-8"
  >
    <p
      class="text-indigo-600 text-xl font-sans font-semibold"
      :class="{ uppercase: titleUpperCase }"
    >
      {{ title }}
    </p>
    <p>Aucune données</p>
  </div>
  <canvas v-else :id="idChart" />
</template>

<script>
export default {
  props: {
    idChart: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    thickness: {
      type: [Number, String],
      required: false,
      default: 10,
    },
    colors: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    positionLegend: {
      type: String,
      required: false,
      default: 'bottom',
    },
    titleColor: {
      type: String,
      required: false,
      default: '#3A18D1',
    },
    titleUpperCase: {
      type: Boolean,
      required: false,
      default: true,
    },
    maintainAspectRatio: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      colorTitle: '#3A18D1',
      upperCaseTitle: true,
      isTitle: true,
    };
  },
  mounted() {
    //Define title color if it's defined in props
    if (this.titleColor != null) {
      this.colorTitle = this.titleColor;
    }

    if (this.titleUpperCase != null) {
      this.upperCaseTitle = this.titleUpperCase;
    }

    if (this.title == '') {
      this.isTitle = false;
    }

    let positionLegend = 'bottom';
    if (this.positionLegend) {
      if (window.matchMedia('(max-width: 1439px)').matches) {
        //If screen too small, legend at bottom
        positionLegend = 'bottom';
      } else {
        positionLegend = this.positionLegend;
      }
    }

    let displayLegend = true;

    if (window.matchMedia('(max-width: 768px)').matches) {
      displayLegend = false;
    }

    let legendFontSize = 13;
    if (window.matchMedia('(max-width: 1024px)').matches) {
      legendFontSize = 11;
    }

    let ctx = document.getElementById(this.idChart);

    let myChart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: this.labels,
        datasets: [
          {
            data: this.values,
            backgroundColor: this.colors,
          },
        ],
      },
      options: {
        cutoutPercentage: this.thickness,
        responsive: true,
        maintainAspectRatio: this.maintainAspectRatio,
        legend: {
          display: displayLegend,
          position: positionLegend,
          fullWidth: false,
          labels: {
            fontColor: '#919AA6',
            fontSize: legendFontSize,
            fontFamily: 'Montserrat',
            usePointStyle: true,
          },
        },
        title: {
          display: this.isTitle,
          text: this.upperCaseTitle ? this.title.toUpperCase() : this.title,
          fontSize: 18,
          fontFamily: 'Montserrat',
          fontColor: this.colorTitle,
          padding: 35,
        },
      },
    });
  },
};
</script>
